// Import model
import { LeadAppointmentCondition } from '../models/LeadAppointmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { LeadAppointmentIndexedFields } from '../models/LeadAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { LeadAppointmentIndexedFieldsSerializer } from './LeadAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadAppointmentCondition - handles JSON serialization and deserialization with type validation
 */
export class LeadAppointmentConditionSerializer {
  /**
   * Deserializes a JSON string into a LeadAppointmentCondition instance
   */
  static deserialize(json: string): LeadAppointmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadAppointmentCondition instance
   */
  static fromObject(obj: any): LeadAppointmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadAppointmentCondition');
    }


    const instance: LeadAppointmentCondition = {
      fieldName: obj['fieldName'] as LeadAppointmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadAppointmentCondition instances
   */
  static deserializeArray(json: string): LeadAppointmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadAppointmentCondition instance to a JSON string
   */
  static serialize(instance: LeadAppointmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadAppointmentCondition instance to a plain object
   */
  static toObject(instance: LeadAppointmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of LeadAppointmentCondition instances to a JSON string
   */
  static serializeArray(instances: LeadAppointmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
